import { Text } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"
import { Button, AppHeader, UserMenu } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SupplierAppLanguageMenu } from "~/components/layout/SupplierAppLanguageMenu"
import { useSupplierUserMenuItems } from "~/components/layout/use-supplier-user-menu-items"
import { useAuth } from "~/store/auth-context"

const useGetSupplierLinkItems = () => {
  const { t } = useTranslation()

  return [
    {
      label: t("supplier.menu.requests"),
      link: "/supplier/requests/traceability",
    },
    {
      label: t("supplier.menu.supplierRequests"),
      link: "/supplier/traceability",
    },
    {
      label: t("supplier.menu.productionSites"),
      link: "/supplier/production-sites",
    },
    {
      label: t("supplier.menu.contacts"),
      link: "/supplier/contacts",
    },
  ]
}

export const SupplierAppHeader = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const supplierMenuItems = useSupplierUserMenuItems()
  const navItems = useGetSupplierLinkItems()

  if (!user) return null

  return (
    <AppHeader
      theme="supplier"
      navItems={navItems}
      h="var(--mantine-supplier-header-height)"
    >
      <SupplierAppLanguageMenu />
      <Button
        component="a"
        fw={700}
        c="var(--mantine-color-text)"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.notion.so/FAQ-Trace-for-Good-b51abcfa27e94403a27449d96327a984?pvs=4"
        rightSection={<IconExternalLink size="1rem" />}
        variant="tertiary"
      >
        <Text>{t("supplier.menu.documentation")}</Text>
      </Button>
      <UserMenu user={user} menuItems={supplierMenuItems} withAvatar={false} />
    </AppHeader>
  )
}
